import oemManager from '../../../services/oem';
import { setEzlogicEnvironment } from '../../../constants/envs';

export const initializeEzlogicOem = async () => {
    await oemManager.initialize();
    setEzlogicEnvironment(oemManager.getEnvironmentKey());
};
